<template>
  <div class="search flex flex-row">
    <el-input
      :placeholder="placeholder"
      v-model.trim="searchValue"
      @keypress.native.enter="search"
      class="search-input"
      maxlength="30"
    >
      <i
        class="el-icon-search el-input__icon search-icon"
        @click="search"
        slot="suffix"
      >
      </i>
    </el-input>
    <div class="search-result" v-if="showNum">
      共
      <span>{{ num }}</span>
      个结果
    </div>
  </div>
</template>
<script>
export default {
  name: "SearchBarCircle",
  props: {
    num: {
      type: Number,
      default: 0,
    },
    value: {
      type: String,
      default: "",
    },
    showNum: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "请输入关键字进行检索",
    },
  },
  computed: {
    // 读取和设置
    searchValue: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    search() {
      this.$emit("btnClick");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
::v-deep.search {
  &-input {
    width: 400px;
    margin-right: 15px;
    > input {
      border-radius: 20px;
      padding-right: 55px;
    }
  }
  &-result {
    line-height: 36px;
    > span {
      color: $theme-color;
      font-weight: bold;
    }
  }
  &-btn:hover {
    /deep/ i {
      color: $theme-color;
      font-weight: bold;
    }
  }
  &-icon {
    color: $theme-color;
    font-size: 20px;
  }
}
</style>
